/**
 * RESPONSIBILITY: a bulletin's date, in words.
 */
import { localDay } from '../commons/local-day';

const LONG = new Intl.DateTimeFormat('en-US', { weekday: 'short', month: 'short', day: 'numeric', year: 'numeric' });
/** Without the year, for the home page's link — this week's is this year's. */
const SHORT = new Intl.DateTimeFormat('en-US', { weekday: 'short', month: 'short', day: 'numeric' });

export function bulletinDay(when: string | Date, short = false): string {
  const day = typeof when === 'string' ? localDay(when) : when;
  return day ? (short ? SHORT : LONG).format(day) : '';
}
